//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

interface DishCategory {
  id: number;
  name: string;
  dishcategorycode: string;
  dishsubcategoryid: number | null;
  costperkg: number;
  costasofdate: string;
  lowerlimitcost: number;
  upperlimitcost: number;
}

interface ApiResponse {
  success: boolean;
  message: string;
  data: {
    dishcategories: DishCategory[];
  };
  responsecode: number;
  errormessage: string | null;
}

interface DishCategoriesState {
  categories: DishCategory[];
  foodprogram: object[];
  loading: boolean;
  error: string | null;
}

const initialState: DishCategoriesState = {
  categories: [],
  foodprogram: [],
  loading: false,
  error: null,
};

// Updated fetchDishCategories function
export const fetchDishCategories = createAsyncThunk<DishCategory[], { userid: string; sitelistid?: number[] }>(
  'dishCategories/fetchDishCategories',
  async ({ userid, sitelistid }) => {
    const payload: { sitelistid?: number[]; userid: string } = {
      userid,
    };

    // Add sitelistid only if it has length
    if (sitelistid && sitelistid.length > 0) {
      payload.sitelistid = sitelistid;
    }

    const response = await axiosInstance.post<ApiResponse>(
      `${BASE_URL}/api/v1/DishCategory/GetDishCategory`,
      payload
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data.dishcategories;
  }
);

export const fetchFoodProgramDayPart = createAsyncThunk(
  'foodProgram/fetchFoodProgramDayPart',
  async (payload) => {
    const response = await axiosInstance.post(`${BASE_URL}/api/v1/FoodProgram/GetFoodProgramByDayPart`,payload);
    return response.data.data.foodprograms;
  }
);

const dishCategoriesSlice = createSlice({
  name: 'dishCategories',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDishCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDishCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchDishCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '';
      });
      builder
      .addCase(fetchFoodProgramDayPart.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFoodProgramDayPart.fulfilled, (state, action) => {
        state.loading = false;
        state.foodprogram = action.payload;
      })
      .addCase(fetchFoodProgramDayPart.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || '';
      });
  },
});

export default dishCategoriesSlice.reducer;
